import getScopedPath from 'owa-url/lib/getScopedPath';
import joinPath from 'owa-url/lib/joinPath';
import { getCurrentModule } from './getCurrentModule';
import { type Module } from 'mini-common-schema';

export const getModuleBasePath = (module: Module) => {
    let moduleName = 'mail';
    let suffix = '';
    switch (module) {
        case 0:
            moduleName = 'mail';
            break;
        case 1:
            moduleName = 'calendar';
            break;
        case 2:
            moduleName = 'people';
            break;
        case 3:
            moduleName = 'mail';
            suffix = 'rewards';
    }

    return `/${joinPath(getScopedPath(moduleName), suffix)}/`;
};

export const getCurrentModuleBasePath = () => {
    return getModuleBasePath(getCurrentModule());
};
